import { defineMessages } from "react-intl";

export const messages = defineMessages({
  // Widget metadata
  widgetName: {
    id: "plugin.luminaverse.name",
    defaultMessage: "Bible Verse",
    description: "Widget name shown in the widget list",
  },
  widgetDesc: {
    id: "plugin.luminaverse.description",
    defaultMessage: "Fetch a Bible verse.",
    description: "Widget description",
  },

  // Verse display
  loading: {
    id: "plugin.luminaverse.loading",
    defaultMessage: "Loading...",
  },
  loadingBooks: {
    id: "plugin.luminaverse.loadingBooks",
    defaultMessage: "Loading books...",
  },
  error: {
    id: "plugin.luminaverse.error",
    defaultMessage: "Unable to load verse",
  },
  placeholder: {
    id: "plugin.luminaverse.placeholder",
    defaultMessage: "Configure your verse in settings",
  },

  // Settings
  title: {
    id: "plugin.luminaverse.title",
    defaultMessage: "Bible Verse",
  },
  subtitle: {
    id: "plugin.luminaverse.subtitle",
    defaultMessage: "Pick how the verse is sourced.",
  },
  refresh: {
    id: "plugin.luminaverse.refresh",
    defaultMessage: "Refresh",
  },
  source: {
    id: "plugin.luminaverse.source",
    defaultMessage: "Source",
  },
  readBible: {
    id: "plugin.luminaverse.readBible",
    defaultMessage: "Read Bible",
  },

  // Modes
  modeFull: {
    id: "plugin.luminaverse.mode.full",
    defaultMessage: "Full Bible",
  },
  modeFullDesc: {
    id: "plugin.luminaverse.mode.fullDesc",
    defaultMessage: "Random verse from the entire Bible",
  },
  modeClassic: {
    id: "plugin.luminaverse.mode.classic",
    defaultMessage: "Classic Verses",
  },
  modeClassicDesc: {
    id: "plugin.luminaverse.mode.classicDesc",
    defaultMessage: "Random verse from 1000 classic refs",
  },
  modeManual: {
    id: "plugin.luminaverse.mode.manual",
    defaultMessage: "Manual Selection",
  },
  modeManualDesc: {
    id: "plugin.luminaverse.mode.manualDesc",
    defaultMessage: "Linked book, chapter, verse and versions",
  },

  // Manual selectors
  reference: {
    id: "plugin.luminaverse.reference",
    defaultMessage: "Reference",
  },
  bookPlaceholder: {
    id: "plugin.luminaverse.bookPlaceholder",
    defaultMessage: "Book",
  },
  chapterPlaceholder: {
    id: "plugin.luminaverse.chapterPlaceholder",
    defaultMessage: "Chapter",
  },
  versePlaceholder: {
    id: "plugin.luminaverse.versePlaceholder",
    defaultMessage: "Verse",
  },
  versions: {
    id: "plugin.luminaverse.versions",
    defaultMessage: "Versions",
  },
  chaptersCount: {
    id: "plugin.luminaverse.chaptersCount",
    defaultMessage: "{count} chapters",
  },
  versesCount: {
    id: "plugin.luminaverse.versesCount",
    defaultMessage: "{count} verses",
  },

  // Typography
  verseFontSize: {
    id: "plugin.luminaverse.verseFontSize",
    defaultMessage: "Verse Font Size",
  },
  verseFontWeight: {
    id: "plugin.luminaverse.verseFontWeight",
    defaultMessage: "Verse Font Weight",
  },
  referenceFontSize: {
    id: "plugin.luminaverse.referenceFontSize",
    defaultMessage: "Reference Font Size",
  },
  referenceFontWeight: {
    id: "plugin.luminaverse.referenceFontWeight",
    defaultMessage: "Reference Font Weight",
  },
});
